<script setup lang="ts">
import { Icon } from '@iconify/vue'
import { useColorMode } from '@/composables/src/useColorMode'
import { Button } from '@/foundation/button'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from '@/foundation/dropdown-menu'

// Pass { disableTransition: false } to enable transitions
const { mode, store } = useColorMode()
</script>

<template>
  <DropdownMenu>
    <DropdownMenuTrigger as-child>
      <Button variant="outline" size="sm" class="h-7">
        <Icon
          icon="radix-icons:moon"
          class="h-[1rem] w-[1rem] rotate-0 scale-100 transition-all dark:-rotate-90 dark:scale-0"
        />
        <Icon
          icon="radix-icons:sun"
          class="absolute h-[1rem] w-[1rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"
        />
        <span class="sr-only">Toggle theme</span>
      </Button>
    </DropdownMenuTrigger>
    <DropdownMenuContent align="end">
      <DropdownMenuItem @click="store = 'light'"> Light </DropdownMenuItem>
      <DropdownMenuItem @click="store = 'dark'"> Dark </DropdownMenuItem>
      <DropdownMenuItem @click="store = 'auto'"> System </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
</template>
